import React from "react";
import { TextInput } from "@mantine/core";

type Props = {
  visible: boolean;
  code: string;
  onCodeChange: (newCode: string) => void;
};

const TwoFactorInput: React.FC<Props> = ({ visible, code, onCodeChange }) => {
  if (!visible) return null;

  const sanitized = code.replace(/\s+/g, "");
  const numeric = /^\d*$/.test(sanitized);
  const validLength = sanitized.length === 6;

  const description =
    sanitized.length === 0
      ? "Get the code from your authenticator app"
      : numeric && !validLength
      ? "Code should be 6 digits"
      : !numeric
      ? "Code should contain only digits"
      : "";

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onCodeChange(e.currentTarget.value.replace(/\s+/g, ""));
  };

  return (
    <TextInput
      label="Enter 2FA Code"
      maxLength={7}
      value={sanitized}
      description={description}
      style={{ maxWidth: 200 }}
      error={
        sanitized.length > 0 && (!numeric || !validLength) ? " " : undefined
      }
      onChange={handleChange}
      mt="md"
    />
  );
};

export default TwoFactorInput;
